// var clickeve = false;
// function inputValidate(){
//   let textbox = document.querySelector('.pplr_text');
//   textbox.addEventListener("input",event =>{
//     textbox.value = textbox.value.replace( /[^a-zA-Z0-9 ]/gm, '');
//   }, false);
  
//   textbox.addEventListener("paste",event =>{
//     textbox.value = textbox.value.replace( /[^a-zA-Z0-9 ]/gm, '');
//   }, false);
// }
function inputValidate() {
  let textbox = document.querySelector('.pplr_text');
  const sanitizeInput = (input) => {
    return input.replace(/[^\p{L}\p{M}a-zA-Z0-9 &\-]/gu, '');
  };
  const removeEmojis = (input) => {
    const emojiRegex = /[\p{Emoji}\p{Emoji_Presentation}\p{Emoji_Modifier_Base}\p{Emoji_Modifier}\p{Emoji_Component}]/gu;
    return input.replace(emojiRegex, '');
  };

  textbox.addEventListener("input", event => {
    let currentValue = textbox.value;
    let inputWithoutEmojis = removeEmojis(currentValue);
    let sanitizedValue = sanitizeInput(inputWithoutEmojis);
    if (currentValue !== sanitizedValue) {
      textbox.value = sanitizedValue;
    }
  }, false);

  textbox.addEventListener("paste", event => {
    setTimeout(() => {
      let currentValue = textbox.value;
      let inputWithoutEmojis = removeEmojis(currentValue);
      let sanitizedValue = sanitizeInput(inputWithoutEmojis);
      if (currentValue !== sanitizedValue) {
        textbox.value = sanitizedValue;
      }
    }, 10);
  }, false);
}
// function inputValidate() {
//   let textbox = document.querySelector('.pplr_text');
//   console.log('here--in',textbox);
//   const sanitizeInput = (input) => {
//     return input.replace(/[^\p{L}\p{M}a-zA-Z0-9 ]/gu, '');
//   };
//   const removeEmojis = (input) => {
//     const emojiRegex = /[\p{Emoji}\p{Emoji_Presentation}\p{Emoji_Modifier_Base}\p{Emoji_Modifier}\p{Emoji_Component}]/gu;
//     return input.replace(emojiRegex, '');
//   };
//   textbox.addEventListener("input", event => {
//     let currentValue = textbox.value;
//     let inputWithoutEmojis = removeEmojis(currentValue);
//     let sanitizedValue = sanitizeInput(inputWithoutEmojis);
//     console.log(currentValue,'input********',sanitizedValue);
//     if (currentValue !== sanitizedValue) {
//       textbox.value = sanitizedValue;
//     }
//   }, false);
//   textbox.addEventListener("paste", event => {
//     setTimeout(() => {
//       let currentValue = textbox.value;
//       console.log(currentValue,'paste********');
//       let inputWithoutEmojis = removeEmojis(currentValue);
//       let sanitizedValue = sanitizeInput(inputWithoutEmojis);
//       if (currentValue !== sanitizedValue) {
//           textbox.value = sanitizedValue;
//       }
//     }, 10);
//   }, false);
// }
window.addEventListener('pplrAppInitiated' , function(e) {
  console.log('loaded');
  if(document.querySelector('.ptc_button') != null){
    document.querySelector('.ptc_button').style.display = 'block';
    if(document.querySelector('.variant-list-inr input[checked]').value.includes('Personalized') 
       || document.querySelector('.variant-list-inr input[checked]').value.includes('Personalisiert') 
       || document.querySelector('.variant-list-inr input[checked]').value.includes('personalization') 
       || document.querySelector('.variant-list-inr input[checked]').value.includes('personaliseren') 
       || document.querySelector('.variant-list-inr input[checked]').value.includes('Personalisierung') 
       || document.querySelector('.variant-list-inr input[checked]').value.includes('Gepersonaliseerd')){
      document.querySelector('.ptc_button').click()
      // document.querySelector('.pplrColor[data-color="'+document.querySelector('.pplrjscolor').getAttribute('data-value').toLowerCase()+'"]').classList.add('selected')
      setTimeout(function(){
        if(window.outerWidth > 991){
          window.scrollTo(0, document.querySelector('.snippet-addto-cart').offsetTop - document.querySelector('header').clientHeight);
        }else{
          window.scrollTo(0, document.querySelector('.snippet-addto-cart').offsetTop + document.querySelector('header').clientHeight);
        }
      }, 100);
      inputValidate();
      // document.querySelector('.product-addcart').classList.add('product_disabled');
      if(document.querySelector('.pplrColor.selected')) document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
    }
    inputValidate();
      document.querySelectorAll('.pplrcheckbox').forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        if (this.checked) {
          document.querySelectorAll('.pplrcheckbox').forEach(function(otherCheckbox) {
            if (otherCheckbox !== checkbox) {
              otherCheckbox.checked = false;
            }
          });
        }
      });
    });

    
    // $(document).on('click','.ptc_button',function(e){
    //   let thisClass = $(this).hasClass('pplr_remove')
    //   if(!thisClass){
    //     param1: 'Personalized'
    //   }
    //   return param1;
    // },personalize_function);
    // function personalize_function(e){
    //   console.log(e,'e///**********');
    // }
    // $(document).on('click','.ptc_button',function(e){param1: 'Personalized'},personalize_function);
    // function personalize_function(e){
    //   console.log(e,e.data,e.data.param1,'param1*****************');
    //   let thisClass = $(this).hasClass('pplr_remove')
    //   $('.option-wrap').each(function(){
    //     if($(this).attr('data-name') == 'Style'){
    //       $(this).find('.variant-list-inr').each(function(){
    //         let val = $(this).find('input').val()
    //         if(thisClass == false){
    //           if(val.includes('Personalized') || val.includes('Personalisiert')){
    //             // $(this).find('input').prop("checked", true);
    //            // if(clickeve == false){
    //               // $(this).find('input').click();
    //            //    return false;
    //            // }
    //           }
    //         }else if(thisClass){
    //           if(!val.includes('Personalized') || !val.includes('Personalisiert')){
    //             // $(this).find('input').prop("checked", true);
    //             // $(this).find('input').click();
    //             // clickeve == false
    //             // return false;
    //           }
    //         }
    //       })
    //     }
    //   })
    // }
    
    // $(document).on('click','.ptc_button',function(e){
    //   let thisClass = $(this).hasClass('pplr_remove')
    //   $('.option-wrap').each(function(){
     
    //     if($(this).attr('data-name') == 'Style'){
    //       $(this).find('.variant-list-inr').each(function(){
    //         let val = $(this).find('input').val()
    //         console.log($(this).find('input').prop("checked"),'**********');
    //         if(thisClass == false){
    //           if(val.includes('Personalized') || val.includes('Personalisiert')){
    //             // $(this).find('input').prop("checked", true);
    //            // if(clickeve == false){
    //            //    $(this).find('input').click();
    //            //    return false;
    //            // }
    //           }
    //         }else if(thisClass){
    //           if(!val.includes('Personalized') || !val.includes('Personalisiert')){
    //             // $(this).find('input').prop("checked", true);
    //             $(this).find('input').click();
    //             clickeve == false
    //             return false;
    //           }
    //         }
    //       })
    //     }
    //   })
    // })
  }
})
// document.querySelector('.ptc_button').addEventListener('click',function(e){
//   console.log('ptc_button clicked');
//   document.querySelectorAll('.option-wrap').forEach(function(label){
//     if(label.getAttribute('data-name') == 'Style'){
//       label.querySelectorAll('.variant-list-inr').forEach(function(item){
//         let val = item.querySelector('input').value
//         if(val.includes('Personalized') && e.srcElement.classList.contains("pplr_remove") == false){
//           item.querySelector('input').click();
//         }else if(!val.includes('Personalized') && e.srcElement.classList.contains("pplr_remove")){
//           item.querySelector('input').click();
//         }
//       });
//     }
//   });
// })

$(document).on('click','.ptc_button', function(event, param1) {
  if (param1 !== 'personalised') {
    if ($('.ptc_button').attr('class').includes('pplr_remove')) {
      console.log('1******');
      $('input[name="Style"]').each(function(index, element){
        if (!($(this).attr('value').includes('Personalized') || $(this).attr('value').includes('Personalisiert') || $(this).attr('value').includes('personalization') || $(this).attr('value').includes('Personalisierung'))) {
          var $this = $(this);
          setTimeout(function(){
            $this.closest('.variant-list-inr').find('input').trigger('click', ['unpersonalized']);
            console.log('selected value', $this.attr('value'));
          }, 100);
          // document.querySelector('.product-addcart').classList.remove('product_disabled');
          document.querySelector('.product-title .th_prd_wl_btn').style.display = 'block';
          document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'flex';
        }
      });
      $('input[name="Stijl"]').each(function(index, element){
        if (!($(this).attr('value').includes('Gepersonaliseerd') || $(this).attr('value').includes('personaliseren'))) {
          var $this = $(this);
          setTimeout(function(){
            $this.closest('.variant-list-inr').find('input').trigger('click', ['unpersonalized']);
            console.log('selected value', $this.attr('value'));
          }, 100);
          // document.querySelector('.product-addcart').classList.remove('product_disabled');
          document.querySelector('.product-title .th_prd_wl_btn').style.display = 'block';
          document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'flex';
        }
      });
      // $('input[name="Size"]').prop("value", "value_to_be_set");
    } else {
      console.log('2*******');
      inputValidate();
      $('input[name="Style"]').each(function(index, element){
        if ($(this).attr('value').includes('Personalized') || $(this).attr('value').includes('Personalisiert') || $(this).attr('value').includes('personalization') || $(this).attr('value').includes('Personalisierung')) {
          var $this = $(this);
          setTimeout(function(){
            $this.closest('.variant-list-inr').find('input').trigger('click', ['unpersonalized']);
            console.log('selected value', $this.attr('value'));
          }, 100);
          // document.querySelector('.product-addcart').classList.add('product_disabled');
          if(document.querySelector('.pplrColor.selected')) document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
          document.querySelector('.product-title .th_prd_wl_btn').style.display = 'none';
          document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'none';
          inputValidate();
        }
      });
      $('input[name="Stijl"]').each(function(index, element){
        if ($(this).attr('value').includes('Gepersonaliseerd') || $(this).attr('value').includes('personaliseren')) {
          var $this = $(this);
          setTimeout(function(){
            $this.closest('.variant-list-inr').find('input').trigger('click', ['unpersonalized']);
            console.log('selected value', $this.attr('value'));
          }, 100);
          // document.querySelector('.product-addcart').classList.add('product_disabled');
          if(document.querySelector('.pplrColor.selected')) document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
          document.querySelector('.product-title .th_prd_wl_btn').style.display = 'none';
          document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'none';
          inputValidate();
        }
      });
    }
  }
});
$(document).on('click', 'input[name="Style"]', function(event, param2){
  console.log('on variant change', $('input[name="Style"]:checked').attr('value'));
  console.log('on variant change', $('.ptc_button').attr('class').includes('pplr_remove'));
  if (param2 !== 'unpersonalized') {
    if($('input[name="Style"]:checked').attr('value').includes('Personalized') || $('input[name="Style"]:checked').attr('value').includes('Personalisiert') || $('input[name="Style"]:checked').attr('value').includes('personalization') || $('input[name="Style"]:checked').attr('value').includes('Personalisierung')) {
      if ($('.ptc_button').attr('class').includes('pplr_remove') == false) {
        $('.ptc_button').trigger('click', ['personalised']);
        // document.querySelector('.product-addcart').classList.add('product_disabled');
        if(document.querySelector('.pplrColor.selected')) document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
        document.querySelector('.product-title .th_prd_wl_btn').style.display = 'none';
        document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'none';
        inputValidate();
      }
    } else {
      if ($('.ptc_button').attr('class').includes('pplr_remove')) {
        $('.ptc_button').trigger('click', ['personalised']);
        // document.querySelector('.product-addcart').classList.remove('product_disabled');
        document.querySelector('.product-title .th_prd_wl_btn').style.display = 'block';
        document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'flex';
      }
    }
  }
})
$(document).on('click', 'input[name="Stijl"]', function(event, param2){
  console.log('on variant change', $('input[name="Stijl"]:checked').attr('value'));
  console.log('on variant change', $('.ptc_button').attr('class').includes('pplr_remove'));
  if (param2 !== 'unpersonalized') {
    if($('input[name="Stijl"]:checked').attr('value').includes('Gepersonaliseerd') || $('input[name="Stijl"]:checked').attr('value').includes('personaliseren')) {
      if ($('.ptc_button').attr('class').includes('pplr_remove') == false) {
        $('.ptc_button').trigger('click', ['personalised']);
        // document.querySelector('.product-addcart').classList.add('product_disabled');
        if(document.querySelector('.pplrColor.selected')) document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
        document.querySelector('.product-title .th_prd_wl_btn').style.display = 'none';
        document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'none';
        inputValidate();
      }
    } else {
      if ($('.ptc_button').attr('class').includes('pplr_remove')) {
        $('.ptc_button').trigger('click', ['personalised']);
        // document.querySelector('.product-addcart').classList.remove('product_disabled');
        document.querySelector('.product-title .th_prd_wl_btn').style.display = 'block';
        document.querySelector('.mb-icons .th_prd_wl_btn').style.display = 'flex';
      }
    }
  }
})
$(document).on('click','.pplrColor',function(e){
  e.preventDefault();
  // $('.product-addcart').removeClass('product_disabled');
  $('.pplrColor.selected').css('border-color',$('.pplrColor.selected').attr('data-color'))
})
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  onVariantChange(){
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if(!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else{
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId(){
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    // if(this.currentVariant.title.includes('Personalized') || this.currentVariant.title.includes('Personalisiert')){
    //   if(!document.querySelector('.ptc_button').classList.contains('.pplr_remove')){
    //     document.querySelector('.ptc_button').click()
    //     setTimeout(function(){
    //       if(window.outerWidth > 991){
    //         window.scrollTo(0, document.querySelector('.snippet-addto-cart').offsetTop + document.querySelector('header').clientHeight);
    //       }else{
    //         window.scrollTo(0, document.querySelector('.snippet-addto-cart').offsetTop - document.querySelector('header').clientHeight);
    //       }
    //     }, 100);
    //     document.querySelector('.product-addcart').classList.add('product_disabled');
    //     document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
    //   }
    // }else{
    //  if(document.querySelector('.ptc_button.pplr_remove') != null){
    //    document.querySelector('.ptc_button.pplr_remove').click()
    //    document.querySelector('.product-addcart').classList.remove('product_disabled');
    //  }
    // }
    // console.log('title',this.currentVariant.title);
    // if(this.currentVariant.title.includes('Personalized') || this.currentVariant.title.includes('Personalisiert')){
    //   console.log('ifff');
    //   this.querySelectorAll('.option-wrap[data-name="Style"] .variant-list-inr input').forEach(function(input){
    //     if(input.value.includes('Personalized')){
    //       if(!document.querySelector('.ptc_button').classList.contains('.pplr_remove')){
            
    //         document.querySelector('.product-addcart').classList.add('product_disabled');
    //         document.querySelector('.pplrColor.selected').style.borderColor = document.querySelector('.pplrColor.selected').getAttribute('data-color')
    //       }
    //     }
    //   });
    // }else{
    //   console.log('elsee');
    //   this.querySelectorAll('.option-wrap[data-name="Style"] .variant-list-inr input').forEach(function(input){
    //     if(!input.value.includes('Personalized')){
    //       if(document.querySelector('.ptc_button.pplr_remove') != null){
    //         document.querySelector('.product-addcart').classList.remove('product_disabled');
    //       }
    //     }
    //   });
    // }
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true){
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] .p-add-cart-btn span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      document.querySelector('.get-notified').classList.remove('d-none');
      document.querySelector('.get-notified').style.display = 'flex'
      if (window.variantStrings.soldOut) addButtonText.textContent = window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      document.querySelector('.get-notified').classList.add('d-none');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] .p-add-cart-btn span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if(document.querySelector('.product-addcart') != null){
  document.querySelector('.product-addcart').addEventListener('click',function(evt){
    evt.preventDefault();
    if(document.querySelector('.variant-list-inr') && document.querySelector('.variant-list-inr input:checked').value.includes('Personalized')){
      if(document.querySelector('.pplrColor.selected')){
        if(document.querySelector('.pplr-color-select')) document.querySelector('.pplr-color-select').classList.remove('no-color-selected');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var cartform = document.querySelector('.product-addcart').closest('form');
        const formData = new FormData(cartform);  
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.querySelector('.product-form-error').innerHTML = response.description;
            setTimeout(function(e){
              document.querySelector('.product-form-error').innerHTML  = '';
            },2000);
            return;
          }else{
            if(typeof load_cart == 'function'){
              cartNotification(response.id);
              load_cart();
              /*setTimeout(function(e){
                document.querySelector('body').classList.add('open-drawer');
              },500);*/
            }else{
              window.location.href = "/cart";
            }
          }
          document.querySelector('.added-cart').style.display = 'flex';
          document.querySelector('.p-add-cart-btn').style.display = 'none';
          setTimeout(function(e){
            document.querySelector('.added-cart').style.display = 'none';
            document.querySelector('.p-add-cart-btn').style.display = 'flex';
          },2000);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
      
        });
      }else{
        if(document.querySelector('.pplr-color-select')) document.querySelector('.pplr-color-select').classList.add('no-color-selected');
      }
    }else{
      if(document.querySelector('.pplr-color-select')) document.querySelector('.pplr-color-select').classList.remove('no-color-selected');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var cartform = document.querySelector('.product-addcart').closest('form');
      const formData = new FormData(cartform);  
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(function(e){
            document.querySelector('.product-form-error').innerHTML  = '';
          },2000);
          return;
        }else{
          if(typeof load_cart == 'function'){
            cartNotification(response.id);
            load_cart();
            /*setTimeout(function(e){
              document.querySelector('body').classList.add('open-drawer');
            },500);*/
          }else{
            window.location.href = "/cart";
          }
        }
        document.querySelector('.added-cart').style.display = 'flex';
        document.querySelector('.p-add-cart-btn').style.display = 'none';
        setTimeout(function(e){
          document.querySelector('.added-cart').style.display = 'none';
          document.querySelector('.p-add-cart-btn').style.display = 'flex';
        },2000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
    
      });
    }
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if($('.media-slider')){
    $('.media-nav').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
      infinite: false,
      adaptiveHeight: true,
	  asNavFor: '.media-thumb',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            infinite: true,
            dots: true
          }
        }
      ]
	});
    $('.media-thumb').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      arrows: true,
      prevArrow:'<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none"><g clip-path="url(#clip0_693_25757)"><path d="M3 5.5L6.5 2M6.5 2L10 5.5M6.5 2L6.5 14.5" stroke="#1A1919" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_693_25757"><rect width="15" height="12" fill="white" transform="translate(0.5 15.5) rotate(-90)"/></clipPath></defs></svg></button>',
      nextArrow:'<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none"><g clip-path="url(#clip0_693_25760)"><path d="M10 10L6.5 13.5M6.5 13.5L3 10M6.5 13.5L6.5 1" stroke="#1A1919" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_693_25760"><rect width="15" height="12" fill="white" transform="translate(12.5) rotate(90)"/></clipPath></defs</svg></button>',
      asNavFor: '.media-nav',
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
          }
        }
      ]
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}
document.querySelectorAll('.meta-color .grid-meta-color li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(window.innerWidth > 991){
      if(color.querySelector('a') != null && document.querySelector('.color_name') != null){
        let colorName = color.querySelector('a').getAttribute('data-val')
        document.querySelector('.color_name h5').textContent = colorName
      }
    }
  })
  color.addEventListener('mouseout',function(){
    if(window.innerWidth > 991){
      if(color.querySelector('a') != null && document.querySelector('.color_name') != null){
        document.querySelector('.color_name h5').textContent = document.querySelector('.meta-color a').getAttribute('data-val')
      }
    }
  })
})
if(document.querySelector('.more_info') != null){
  document.querySelector('.more_info').addEventListener('click',function(e){
    e.preventDefault();
    if(window.outerWidth > 991){
      setTimeout(function(){
        window.scrollTo(0, document.getElementById('product-accordion').offsetTop + document.querySelector('header').clientHeight);
      }, 10);
    }else{
      setTimeout(function(){
        window.scrollTo(0, document.getElementById('product-accordion').offsetTop - document.querySelector('header').clientHeight);
      }, 10);
    }
  })
}
if(document.querySelector('.play_video') != null){
  document.querySelector('.play_video').addEventListener('click',function(){
    document.querySelector('.personalize-video video').play();
    document.querySelector('.play_video').style.display = 'none';
  })
}
if(document.querySelector('.media-nav') != null){
  document.querySelector('.media-nav').addEventListener('click',function(e){
    e.preventDefault();
    if(window.innerWidth > 991){
      document.querySelector('body').classList.add('zoom-open');
    }
  })
}
if(document.querySelector('.zoom-main') != null){
  document.querySelector('.zoom-main').addEventListener('click',function(e){
    e.preventDefault();
    if(window.innerWidth > 991){
      setTimeout(function(){
        $('.media-thumb')[0].slick.animateHeight();
        $('.media-nav')[0].slick.refresh()
      }, 200);
      document.querySelector('body').classList.remove('zoom-open');
    }
  })
}
if(document.querySelector('.mb-zoom-btn') != null){
  document.querySelector('.mb-zoom-btn').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('zoom-open');
    let swiper = new Swiper(".zoom-main",{
      slidesPerView: "auto",
      pagination:{
        el: ".zoom-pagination",
        clickable: true,
      },
    });
  })
}
if(document.querySelector('.mb-zoom-close a') != null){
  document.querySelector('.mb-zoom-close a').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('zoom-open');
  })
}
// if(document.querySelector('.combine-with-colorlist a') != null){
//   document.querySelector('.mb-zoom-close a').addEventListener('click',function(e){
//     e.preventDefault();
//     document.querySelector('body').classList.remove('zoom-open');
//   })
// }
document.addEventListener("DOMContentLoaded", () => {
  var totalheight = document.querySelector('.snippet-addto-cart').offsetTop;
  var widnowheight = window.outerHeight
  var otherTop = document.getElementById('shopify-section-footer').offsetTop
  window.addEventListener('scroll', (e)=>{
    var cartheight = totalheight - widnowheight;    
    var scroll = window.pageYOffset;
    if(scroll >= (totalheight + 150)){
      document.querySelector('body').classList.add('stickybar');
    }else{
      document.querySelector('body').classList.remove('stickybar');
    }
    if((scroll >= (otherTop + cartheight))){
      document.querySelector('body').classList.remove('stickybar');
    }
  });
});
if(document.querySelector('.sticky-addcart') != null){
  document.querySelector('.sticky-addcart').addEventListener('click',function(){
    setTimeout(function(e){document.querySelector('.product-addcart').click();},1000);
  })
}
if(document.querySelector('.cw-color-btn') != null){
  document.querySelector('.cw-color-btn').addEventListener('click',function(e){
    e.preventDefault();
    this.closest('.combine-with-colors').classList.toggle('active');
  })
}
$(document).on('click', 'body', function(e){
  var tag = $('.combine-with-colorlist,.cw-color-btn');
  if (!tag.is(e.target) && tag.has(e.target).length === 0) {
    $('.combine-with-colors').removeClass('active')
  }
});
if(document.querySelector('.combine-with-colorlist a')){
  document.querySelectorAll('.combine-with-colorlist a').forEach(function(colors){
    colors.addEventListener('click',function(event){
      event.preventDefault();
      let text = document.querySelector('.cw-color-btn span').textContent
      let id = document.querySelector('.cw-color-btn').getAttribute('data-id')
      let price = document.querySelector('.cw-color-btn').getAttribute('data-price')
      let title = document.querySelector('.cw-color-btn').getAttribute('data-title')
      let img = document.querySelector('.cw-color-btn').getAttribute('data-img')
      document.querySelector('.cw-color-btn span').textContent = this.textContent
      document.querySelector('.cw-color-btn').setAttribute('data-id',this.getAttribute('data-id',id))
      document.querySelector('.cw-color-btn').setAttribute('data-price',this.getAttribute('data-price',price))
      document.querySelector('.cw-color-btn').setAttribute('data-title',this.getAttribute('data-title',title))
      document.querySelector('.cw-color-btn').setAttribute('data-img',this.getAttribute('data-img',img))
      document.querySelector('.combine-with-cart').setAttribute('data-id',this.getAttribute('data-id'))
      document.querySelector('.combine-with-media img').setAttribute('src',this.getAttribute('data-img'))
      document.querySelector('.combine-with-meta p').textContent = this.getAttribute('data-title')
      document.querySelector('.combine-with-meta .cw-price').innerHTML = this.getAttribute('data-price')
      this.textContent = text
      this.setAttribute('data-id',id)
      this.setAttribute('data-img',img)
      this.setAttribute('data-title',title)
      this.setAttribute('data-price',price)
      document.querySelector('.combine-with-colors').classList.remove('active');
    });
  });
}
if(document.querySelector('.combine-with-cart') != null){
  document.querySelector('.combine-with-cart').addEventListener('click',function(){
    let data_line = this.getAttribute('data-id');
    const data = {quantity: 1, id: data_line}
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((data) => {
      if(typeof load_cart == 'function'){
        cartNotification(data.id);
        load_cart();
        /*setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);*/
      }else{
        window.location.href = "/cart";
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  })
}
var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 991) {
    if (!init) {
      init = true;
      swiper = new Swiper(".prod-tm-media", {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
function accordian(){
  const accordions = document.querySelectorAll(".accordian-wrap");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
    content.style.maxHeight = (content.scrollHeight + 30) + "px";
  };
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };
  var first_accordian = document.querySelector(".accordian-wrap.active");
  if(first_accordian){
    var first_content = first_accordian.querySelector(".accordian-content");    
  }
  if(first_content){
    first_content.style.maxHeight = first_content.scrollHeight + "px";
  }
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    intro.onclick = (e) => {
      e.preventDefault();
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);
      }
    };
  });
}
accordian();
document.addEventListener("shopify:section:load", function(event) {
  accordian();
});

if (document.querySelector('.snippet-addto-cart .coming-soon') != null ) {
  var form = document.querySelector('.main-cs-form');
  var btn = document.querySelector('.snippet-addto-cart .coming-soon');
  document.querySelector('.snippet-addto-cart .coming-soon').addEventListener('click', function (e) {
    btn.classList.add('hide');
    form.classList.remove('hide');
  });
}
if (document.querySelector('.main-cs-form .cs-form-close') != null ) {
  document.querySelector('.main-cs-form .cs-form-close').addEventListener('click', function (e) {
    var form = document.querySelector('.main-cs-form');
    var btn = document.querySelector('.snippet-addto-cart .coming-soon');
    form.classList.add('hide');
    btn.classList.remove('hide');
  });
}

// Back in stock form functionality
document.querySelectorAll('.snippet-addto-cart .get-notified').forEach(function(btn, index) {
  var bisForm = btn.closest('.snippet-addto-cart').querySelector('.main-bis-form');
  var chooseCart = btn.closest('.choose-cart');
  if (bisForm && btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.style.display = 'none';
      bisForm.classList.remove('hide');
      if (chooseCart) {
        chooseCart.classList.add('bis-form-open');
      }
    });
  }
});

document.querySelectorAll('.main-bis-form .bis-form-close').forEach(function(closeBtn) {
  closeBtn.addEventListener('click', function (e) {
    var bisForm = closeBtn.closest('.main-bis-form');
    var bisBtn = bisForm.parentNode.querySelector('.get-notified');
    var chooseCart = bisForm.parentNode.querySelector('.choose-cart');
    if (bisForm && bisBtn) {
      bisForm.classList.add('hide');
      bisBtn.style.display = 'flex';
      if (chooseCart) {
        chooseCart.classList.remove('bis-form-open');
      }
    }
  });
});

// Check if customer form was successfully submitted and reopen the BIS form - only on product pages
if (window.location.pathname.includes('/products/') && window.location.search.includes('customer_posted=true') && window.location.hash.includes('contact_form')) {
  var bisForm = document.querySelector('.main-bis-form');
  var bisBtn = document.querySelector('.snippet-addto-cart .get-notified');
  var chooseCart = document.querySelector('.choose-cart');
  
  if (bisForm && bisBtn) {
    bisBtn.style.display = 'none';
    bisForm.classList.remove('hide');
    if (chooseCart) {
      chooseCart.classList.add('bis-form-open');
    }
  }
}

